import React from 'react';
import { STAGE_ORDER, stageLabel } from '../../lib/onboardingDisplay';

/**
 * Controlled stage filter. Counts in; active stage + onSelectStage out.
 * @param {{ counts: Record<string, number>, activeStage: string|null, onSelectStage: (stage: string|null) => void }} props
 */
export function FleetStatusStrip({ counts, activeStage, onSelectStage }) {
  return (
    <div className="fleet-status-strip" role="group" aria-label="Filter devices by onboarding stage">
      {STAGE_ORDER.map((stage) => {
        const isActive = activeStage === stage;
        return (
          <button
            key={stage}
            type="button"
            className={`stage-chip${isActive ? ' stage-chip--active' : ''}`}
            aria-pressed={isActive}
            onClick={() => onSelectStage(isActive ? null : stage)}
          >
            {stageLabel(stage)} ({counts[stage] || 0})
          </button>
        );
      })}
    </div>
  );
}
